export const DEFAULT_FLOW_SUBFORM_NAMESPACE = 'flow.default';
